module.exports = __webpack_public_path__ + "static/media/ic_联系我们.44573653.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_联系我们.svg
// module id = 188
// module chunks = 0